import React from "react";
import { Hero } from "../Components/Hero/Hero.tsx";
import { About } from "../Components/About/About.tsx";
import { Services } from "../Components/Services/Services.tsx";
import { Process } from "../Components/Process/Process.tsx";
import { Contact } from "../Components/Contact/Contact.tsx";
import { Footer } from "../Components/Footer/Footer.tsx";
import { Navigation } from "../Components/Nav/Navigation.tsx";

export const SPA = () => (
  <>
    <Navigation />
    <main>
      <Hero />
      <Services />
      <Process />
      <About />
      <Contact />
    </main>
    <Footer />
  </>
);
